import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import styles from './SliderButton.module.scss';

const SliderButton = ({
  direction,
  className,
  innerRef,
  ButtonComponent,
  ...rest
}) => {
  const sizeProps = { width: 24, height: 20 };

  return (
    <div
      className={clsx(className, styles.arrowNavigation)}
      ref={innerRef}
      data-carousel-arrow={`arrow_${direction}`}
      {...rest}
    >
      <ButtonComponent {...sizeProps} />
    </div>
  );
};

SliderButton.propTypes = {
  className: PropTypes.string,
  innerRef: PropTypes.object,
  direction: PropTypes.oneOf(['right', 'left']).isRequired,
  ButtonComponent: PropTypes.elementType.isRequired,
};

export default SliderButton;
